module.exports = __webpack_public_path__ + "img/saham.a398916e.jpg";